<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="tabPath">外呼明细</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel>
      <template slot="header">列表</template>
      <template slot="tools">
        <el-button type="primary"
                   size="small"
                   icon="el-icon-refresh"
                   @click="onRefresh()"></el-button>
      </template>
      <el-table :data="table"
                stripe
                highlight-current-row
                border
                style="width: 100%">
        <el-table-column prop="id"
                         label="ID"
                         min-width="90">
        </el-table-column>
        <el-table-column prop="created_at"
                         label="拨打时间"
                         min-width="120"></el-table-column>
        <el-table-column prop="status"
                         label="外呼状态"
                         min-width="120">
          <template slot-scope="scope">
            <span>{{recordStatus[scope.row.status]}}</span>
          </template>
        </el-table-column>
        <el-table-column fixed="right"
                         label="操作"
                         width="110">
          <template slot-scope="scope">
            <div class="button-gutter">
              <el-button v-if="[2].includes(scope.row.status) && scope.row.record_url" size="mini" @click="dowloadAudio(scope.row)">下载录音</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div> -->
    </layout-panel>
  </div>
</template>

<script>
import { searchRules } from '../intelligent-outbound-call.rules.js'
import dateTimePicker from '@core/mixins/dateTimePicker'
import table from '@core/mixins/table-v3'

export default {
  mixins: [table, dateTimePicker],
  components: {},
  data () {
    return {
      searchRules,
      search: {
      },
    }
  },
  computed: {
    ...Vuex.mapState({
      recordStatus: state => state.intelligentOutboundCall.recordStatus,
    }),
    tabPath () {
      return `/intelligent-outbound-call/detail-table/${this.$route.query.callTaskId}`
    }
  },
  created () {},
  methods: {
    ...Vuex.mapActions([]),
    ...request.map([]),
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData (params) {
      return request.page('getIntelligentOutboundCallRecordTable', params)
    },
    setTableData ({data}) {
      this.$set(this, 'table', data)
      this.setPagination(data)
    },
    getexportCallDetailData (params) {
      return request.page('exportCallDetailData', params)
    },
    dowloadAudio (row) {
      const downloadFile = document.createElement('a')
      document.body.append(downloadFile)
      downloadFile.href = row.record_url
      downloadFile.rel = 'noopener noreferrer'
      downloadFile.click()
      document.body.removeChild(downloadFile)
    },
  },
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
.option-cantor {
  display: flex;
  align-items: center;;
}
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/intelligent-outbound-call/pages/IntelligentOutboundCallRecordTable.vue